export const LISTE_MODE_REGLEMENT = {
  title: 'Liste des modes de règlement',
  actions: {
    add: 'Ajouter un mode de règlement',
    search: 'Rechercher',
    archive: 'Afficher les modes de règlements archivés',
  },
  tab: {
    libelle: 'Libellé',
    aEffet: 'A effet',
    centralisationCompteBanque: 'Centralisation compte banque',
    ribObligatoire: 'RIB obligatoire',
    actionAchat: 'Action achat',
    traite: 'Traite',
    prelevement: 'Prélèvement',
    codeExterneComptabilite: 'Code externe comptabilité',
    codeExterneFactor: 'Code externe factor',
  },
  actionAchat: {
    aucun: 'Non utilisé',
    lettreCheque: 'Lettre Chèque',
    virement: 'Virement',
    autres: 'Autre',
  },
};

export const ADD_MODE_REGLEMENT = {
  titleAdd: 'Ajouter un mode de règlement',
  titleEdit: 'Modifier un mode de règlement',
  actions: {
    add: 'Ajouter',
    edit: 'Modifier',
    cancel: 'Annuler',
  },
  informationModeReglement: {
    libelle: 'Libellé',
    aEffet: 'A effet',
    centralisationCompteBanque: 'Centralisation compte banque',
    ribObligatoire: 'RIB obligatoire',
    actionAchat: 'Action achat',
    traite: 'Traite',
    prelevement: 'Prélèvement',
    codeExterneComptabilite: 'Code externe comptabilité',
    codeExterneFactor: 'Code externe factor',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  success: {
    add: 'Le mode de règlement a été ajouté avec succès.',
    edit: 'Le mode de règlement a été modifié avec succès.',
  },
};
